import { NewsAndUpdatesDialog, PendingInvitesModal, WelcomeBanner } from 'pages/dashboard/components';
import { DefaultLayout } from 'components/layout';
import * as Tiles from 'pages/dashboard/tiles';
import { useIntl } from 'react-intl';

import 'pages/dashboard/styles/Dashboard.scss';

import { ERole } from 'types';
import { useApp } from 'app';

const MAX_CONTENT_WIDTH = 960;

export const Dashboard = () => {

    const { highestRole } = useApp();
    const { formatMessage } = useIntl();

    const roleId = highestRole?.id;

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'home.9d181c03', defaultMessage: 'Home' })}>
            <div className="dashboard d-flex flex-column gap-3">

                <WelcomeBanner />

                <div className="d-flex flex-column flex-xl-row gap-3">

                    <div className="dashboard-segment d-flex flex-column gap-3 flex-xl-fill w-100" style={{ maxWidth: MAX_CONTENT_WIDTH }}>

                        <Tiles.Promo />

                        <div className={'d-xl-none'}>
                            <Tiles.Messages />
                        </div>

                        <Tiles.QuickLinks />

                        <Tiles.QuickReports />

                        {[ERole.SYSADMIN, ERole.TESTING_CENTER].includes(roleId) && <Tiles.LTI />}

                        {roleId === ERole.TESTING_CENTER && <Tiles.VendorPanels />}

                        <Tiles.Tutorials />

                    </div>

                    <div className={'dashboard-segment d-none d-xl-block flex-xl-fill'} style={{ maxWidth: '50%' }}>
                        <Tiles.Messages />
                    </div>

                </div>

                <NewsAndUpdatesDialog />

                <PendingInvitesModal />

            </div>
        </DefaultLayout>
    );

};